var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button floated-buttons is-dark is-back-button",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_c('fa',{attrs:{"icon":"arrow-left","is-fullwidth":"","size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }